{
    "Profile_CommonComponents_DiscountBadges.discounts": " Discounts ",
    "Profile_CommonComponents_DiscountBadges.DISCF.label1": "Conviction",
    "Profile_CommonComponents_DiscountBadges.DISCF.label2": "Free",
    "Profile_CommonComponents_DiscountBadges.DISMP.label1": "Multi",
    "Profile_CommonComponents_DiscountBadges.DISMP.label2": "Line",
    "Profile_CommonComponents_DiscountBadges.DISMV.label1": "Multi",
    "Profile_CommonComponents_DiscountBadges.DISMV.label2": "Vehicle",
    "Profile_CommonComponents_DiscountBadges.DISNB.label1": "New",
    "Profile_CommonComponents_DiscountBadges.DISNB.label2": "Customer",
    "Profile_CommonComponents_DiscountBadges.DISNC.label1": "No",
    "Profile_CommonComponents_DiscountBadges.DISNC.label2": "Claims",
    "Profile_CommonComponents_DiscountBadges.DISSN.label1": "Winter",
    "Profile_CommonComponents_DiscountBadges.DISSN.label2": "Tires",
    "Profile_CommonComponents_DiscountBadges.ZDSAB.label1": "Autonomous",
    "Profile_CommonComponents_DiscountBadges.ZDSAB.label2": "Braking",
    "Profile_CommonComponents_DiscountBadges.GENERIC.label1": "Carrier",
    "Profile_CommonComponents_DiscountBadges.GENERIC.label2": "Discount"
}
